
import  axios  from 'axios';
import {loadCompanysDataWithUserId} from "../company";
import {loadSingleUserDataInStore,loadSingleUserData,getSingleUser} from "../user/actions";
import {clearAllFiltersInStore, SET_CLEAR_ALL_FILTER} from "../fax/actions";

import AppUtils from "../../../utils/AppUtils";

export const LOAD_TOWJOB_DATA = 'towjob/LOAD_TOWJOB_DATA';
export const DELETE_A_TOWJOB = 'towjob/DELETE_A_TOWJOB';
export const SAVE_A_TOWJOB = 'towjob/SAVE_A_TOWJOB';
export const UPDATE_A_TOWJOB = 'towjob/UPDATE_A_TOWJOB';
export const SET_TOW_STATUS_FILTER = 'towjob/SET_TOW_STATUS_FILTER';
export const SET_TOW_VIN_FILTER = 'towjob/SET_TOW_VIN_FILTER';
export const SET_TOW_PLATE_FILTER = 'towjob/SET_TOW_PLATE_FILTER';
export const SET_TOW_STARTTIME_FILTER = 'towjob/SET_TOW_STARTTIME_FILTER';
export const SET_TOW_ENDTIME_FILTER = 'towjob/SET_TOW_ENDTIME_FILTER';
export const SET_TOW_MODEL_FILTER = 'towjob/SET_TOW_MODEL_FILTER';
export const SET_TOW_MAKE_FILTER = 'towjob/SET_TOW_MAKE_FILTER';
export const SET_TOW_COLOR_FILTER = 'towjob/SET_TOW_COLOR_FILTER';
export const SET_TOW_YEAR_FILTER = 'towjob/SET_TOW_YEAR_FILTER';
export const SET_TOW_CLEAR_ALL_FILTER = 'towjob/SET_TOW_CLEAR_ALL_FILTER';
export const CLEAR_A_TOWJOB_ERROR_MESSAGE = 'towjob/CLEAR_A_TOWJOB_ERROR_MESSAGE';
export const UPLOAD_TOWJOB_PICTURE = 'towjob/UPLOAD_TOWJOB_PICTURE';
export const GET_TOWJOB_PICTURE_IDS = 'towjob/GET_TOWJOB_PICTURE_IDS';
//export const UPDATE_TOW_JOBS_ARRAY = 'towjob/UPDATE_TOW_JOBS_ARRAY';





export function loadTowJobsPictureIdsInStore(argTowjobDataArray,argErrorMsg) {
    return {
        type: GET_TOWJOB_PICTURE_IDS,
        towjobspictureids:argTowjobDataArray,
        errorMsg:argErrorMsg
    }
}


export function uploadATowPictureInStore(argTowUploadResponse ,argErrorMsg) {
    return {
        type: UPLOAD_TOWJOB_PICTURE,
        towUploadResponse:argTowUploadResponse,
        errorMsg:argErrorMsg
    }
}

export function clearTowErrorMsgInStore(){
    return {
        type: CLEAR_A_TOWJOB_ERROR_MESSAGE,
        
    }
}

export function loadTowjobDataInStore(argTowjobDataArray) {
    return {
        type: LOAD_TOWJOB_DATA,
        towjobsData:argTowjobDataArray
    }
}
export function deleteATowjobInStore(argDeleteResponse, argErrorMsg) {
    return {
        type: DELETE_A_TOWJOB,
        deleteTowjobResponse:argDeleteResponse,
        errorMsg:argErrorMsg
    }
}

export function saveATowjobDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: SAVE_A_TOWJOB,
        saveTowjobResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function updateATowjobDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: UPDATE_A_TOWJOB,
        updateTowjobResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}


export function setTowStatusFilterInStore(argFilter ) {
    return {
        type: SET_TOW_STATUS_FILTER,
        towStatusFilter:argFilter,
    }
}


export function setTowVinFilterInStore(argFilter ) {
    return {
        type: SET_TOW_VIN_FILTER,
        towVinFilter:argFilter,
    }
}

export function setTowPlateFilterInStore(argFilter ) {
    return {
        type: SET_TOW_PLATE_FILTER,
        towPlateFilter:argFilter,
    }
}

export function setTowStartTimeFilterInStore(argFilter ) {
    return {
        type: SET_TOW_STARTTIME_FILTER,
        towStartTimeFilter:argFilter,
    }
}

export function setTowEndTimeFilterInStore(argFilter ) {
    return {
        type: SET_TOW_ENDTIME_FILTER,
        towEndTimeFilter:argFilter,
    }
}

export function setTowModelFilterInStore(argFilter ) {
    return {
        type: SET_TOW_MODEL_FILTER,
        towModelFilter:argFilter,
    }
}

export function setTowMakeFilterInStore(argFilter ) {
    return {
        type: SET_TOW_MAKE_FILTER,
        towMakeFilter:argFilter,
    }
}

export function setTowColorFilterInStore(argFilter ) {
    return {
        type: SET_TOW_COLOR_FILTER,
        towColorFilter:argFilter,
    }
}

export function setTowYearFilterInStore(argFilter ) {
    return {
        type: SET_TOW_YEAR_FILTER,
        towYearFilter:argFilter,
    }
}

export function clearTowAllFiltersInStore() {
    return {
        type: SET_TOW_CLEAR_ALL_FILTER,
        
    }
}

/*export function updateTowJobsArrayInStore(argTowJobsArray){
    return {
        type: UPDATE_TOW_JOBS_ARRAY,
        towjobsArray:argTowJobsArray,
    }
    
}*/

/********************* End of InStore calls **************************/
//****************************************
//Below is for update a Stream
//****************************************
export function clearTowErrorMsg(){
    return (dispatch, getState) => {
        dispatch(clearTowErrorMsgInStore());
    }
}

//****************************************
//Below is for update a Stream
//****************************************
export function updateATowjob(argURL, argTowJob, argCompanyId) {
    console.log("Teh company ID is " +argCompanyId);
    console.log("Teh cargURI " +argURL);
    console.log(argTowJob);
    return (dispatch, getState) => {
        const state = getState();
        updateATowjobOnServer(argURL, argTowJob, argCompanyId ,state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){
            
            dispatch(updateATowjobDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));
            
        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            console.log("I had an error updating a Tow Job" + errorObj.statusText + errorObj.status);
            dispatch(updateATowjobDataInStore({}, errorObj));
        });
    }//end of return
}


function updateATowjobOnServer( argURL, argTowJob, argCompanyId ,argIdToken, argUserId){
    
    var returnPromise = new Promise(function(resolve, reject){
        
        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPutsForUpdateATowjob(argURL, argTowJob, argCompanyId ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                console.log("Farshid some error occured on saving a StorageLot " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });
    
    return returnPromise;
}



function getArrayOfPutsForUpdateATowjob(argURL, argTowjob,argCompanyId ,argIdToken, argUserId ){
    
    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/towjobs/"+argTowjob.id ;
    console.log(" on posting a towjob the URL is " + baseUrl );
    
    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.put(baseUrl,argTowjob ,{headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for save a Stream
//****************************************
export function saveATowjob(argURL, argTowjobInfo, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        saveATowjobOnServer(argURL, argTowjobInfo, argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){
            
            dispatch(saveATowjobDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText} ));
            
        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            //console.log("I had an error saving a Tow Job " + err.response.statusText + err.response.status );
            dispatch(saveATowjobDataInStore({}, errorObj ));
        });
    }//end of return
}


function saveATowjobOnServer( argURL, argTowjobInfo, argCompanyId  ,argIdToken, argUserId){
    
    var returnPromise = new Promise(function(resolve, reject){
        
        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPostsForSaveATowjob(argURL, argTowjobInfo, argCompanyId  ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                console.log("Farshid some error occured on saving a towjob " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });
    
    return returnPromise;
}



function getArrayOfPostsForSaveATowjob(argURL, argCamera, argCompanyId ,argIdToken, argUserId){
    /*
     I build something like this :
     http://localhost:4567/companys
     */
    
    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/towjobs";
    console.log(" on posting a towjob the URL is " + baseUrl );
    
    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.post(baseUrl,argCamera ,{headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Add TowJob to the TowJobs Array
//****************************************
export function addTowjobToTowJobsArray(argTowJob ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempTowJobsArray=[] ;
        tempTowJobsArray = Object.assign(tempTowJobsArray,state.towjob.towjobsArray);
        //first we try to remove any with the same id.
        let newArray = tempTowJobsArray.filter(element => { return element.id != argTowJob.id });
        //adding to the top of the array.
        newArray.unshift(argTowJob);
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadTowjobDataInStore(newArray));
    }//end of return
}

//****************************************
//Delete TowJob from the TowJobs Array
//****************************************
export function deleteTowjobFromTowJobsArray(argTowJobId ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempTowJobsArray=[] ;
        tempTowJobsArray = Object.assign(tempTowJobsArray,state.towjob.towjobsArray);
        //removig the match element with the matching id.
        let newArray = tempTowJobsArray.filter(element => { return element.id != argTowJobId.id });
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadTowjobDataInStore(newArray));
    }//end of return
}
//****************************************
//update TowJob in the TowJobs Array
//****************************************
export function updateTowjobInTowJobsArray(argTowJob ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempTowJobsArray=[] ;
        tempTowJobsArray = Object.assign(tempTowJobsArray,state.towjob.towjobsArray);
        //rempoving the item from the array and then add the updated one to the array array.
        let newArray = tempTowJobsArray.filter(element => { return element.id != argTowJob.id });
        //adding to the top of the array.
        newArray.unshift(argTowJob);
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadTowjobDataInStore(newArray));
    }//end of return
}


//****************************************
//Below is for delete a company
//****************************************
export function deleteATowjob(argURL, argCameraId, argCompanyId ) {
    return (dispatch, getState) => {
        const state = getState();
        deleteATowjobOnServer(argURL, argCameraId,argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(deleteResponse){
            
            dispatch(deleteATowjobInStore(deleteResponse, null));
            
        }, function(err){
            console.log("I had an error gettting Stream Data2" + err);
            dispatch(deleteATowjobInStore({}, err));
        });
    }//end of return
}


function deleteATowjobOnServer( argURL, argStreamId,argCompanyId,  argIdToken, argUserId){
    
    var returnPromise = new Promise(function(resolve, reject){
        
        
        
        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfDeletesForDeleteATowjob(argURL, argStreamId, argCompanyId , argIdToken, argUserId)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on deleteing a Towjob " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });
    
    return returnPromise;
}



function getArrayOfDeletesForDeleteATowjob(argURL, argRealCompanyId, argStorageId, argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/cameras
     */
    
    let baseUrl = argURL+"users/"+ argUserId+"/companies"+"/"+argRealCompanyId+"/towjobs/"+argStorageId;
    console.log(" on deleteing a Towjob the URL is " + baseUrl );
    
    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.delete(baseUrl, {headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}


//Get list of towjobs

export function loadTowjobsData(argURL, argCompanyId) {
    if(argCompanyId !== null) {
        return (dispatch, getState) => {
            const state = getState();
            
            if ((state.user.saveUserResp == null) || (state.user.saveUserResp.id == null) || (state.user.saveUserResp.id == undefined)) {
                getSingleUser(argURL, state.login.loginData.idToken).then(function (userData) {
                    
                    // dispatch(loadTowjobDataInStore(companysList));
                    dispatch(loadSingleUserDataInStore(userData));
                    dispatch(loadCompanysDataWithUserId(argURL, userData.id));
                    
                    getListOfTowjobs(argURL, state.company.selectedCompany, state.login.loginData.idToken, userData.id).then(function (companysList) {
                        
                        dispatch(loadTowjobDataInStore(companysList));
                        
                    }, function (err) {
                        console.log("I had an error gettting loadTowjobsData" + err);
                    });
                    
                }, function (err) {
                    console.log("I had an error gettting Farms Data2" + err);
                });
                
                
            } else {
                getListOfTowjobs(argURL, state.company.selectedCompany, state.login.loginData.idToken, state.user.saveUserResp.id).then(function (companysList) {
                    
                    dispatch(loadTowjobDataInStore(companysList));
                    
                }, function (err) {
                    console.log("I had an error getting loadTowjobsData" + err);
                })
            }
            ;
        }//end of return
    }
    }
    
    function getArrayOfGetsForListOfTowjobs(argURL,argCompanyId ,argIdToken, argUserId  ){
        /*
				 I build something like this :
				 http://localhost:4567/company
				 */
        
        let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/towjobs";
        console.log(" on getting list of Towjobs  the URL is " + baseUrl );
        
        var arrayOfGets = [];
        if(argURL != null) {
            arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
        }
        return arrayOfGets;
    }
    
    function getListOfTowjobs( argURL, argCompanyId ,argIdToken, argUserId ){
        
        var returnPromise = new Promise(function(resolve, reject){
            
            var arrayOfGets = [];
            
            if((argURL != null) || (argURL.length != 0)){
                axios.all(getArrayOfGetsForListOfTowjobs(argURL, argCompanyId ,argIdToken, argUserId )).then(function(responses){
                    resolve(responses[0].data);
                }, function(err) {
                    console.log("Farshid some error occured on getting list of Storage " + err.message +  " the URL is " + argURL );
                    reject(err);
                });
            }
        });
        
        return returnPromise;
    }


//These are for loadJobsWIthFilters
    export function loadTowjobsDataWithFilter(argURL, argCompanyId, argFilter) {
       if((argCompanyId !== null)&&( argCompanyId !== undefined)) {
           return (dispatch, getState) => {
               const state = getState();
               getListOfTowjobsWithFilter(argURL, state.company.selectedCompany, state.login.loginData.idToken, state.user.saveUserResp.id, argFilter).then(function (companysList) {
                   
                   dispatch(loadTowjobDataInStore(companysList));
                   
               }, function (err) {
                   console.log("I had an error gettting Farms Data2" + err);
               });
           }//end of return
       }
    }
    
    function getListOfTowjobsWithFilter( argURL, argCompanyId ,argIdToken, argUserId, argFilter ){
        
        var returnPromise = new Promise(function(resolve, reject){
            
            var arrayOfGets = [];
            
            if((argURL != null) || (argURL.length != 0)){
                axios.all(getArrayOfGetsForListOfTowjobsWithFilter(argURL, argCompanyId ,argIdToken, argUserId, argFilter )).then(function(responses){
                    resolve(responses[0].data);
                }, function(err) {
                    console.log("Farshid some error occured on getting list of Tow Jobs " + err.message +  " the URL is " + argURL );
                    reject(err);
                });
            }
        });
        
        return returnPromise;
    }
    function getArrayOfGetsForListOfTowjobsWithFilter(argURL,argCompanyId ,argIdToken, argUserId, argFilter  ){
        /*
				 I build something like this :
				 http://localhost:4567/company
				 */
        
        let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/towjobs"+argFilter;
        console.log(" on getting list of Towjobs  filter the URL is " + baseUrl );
        
        var arrayOfGets = [];
        if(argURL != null) {
            arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
        }
        return arrayOfGets;
    }


//These are upload funcations
//


//****************************************
//Below is Upload
//****************************************
    export function uploadATowPicture(argURL, argFormData, argCompanyId) {
        return (dispatch, getState) => {
            const state = getState();
            uploadATowPictureOnServer(argURL, argFormData, argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){
                
                dispatch(uploadATowPictureInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText} ));
                
            }, function(err){
                var errorObj = AppUtils.getErroStatusAndText(err);
                //console.log("I had an error saving a Tow Job " + err.response.statusText + err.response.status );
                dispatch(uploadATowPictureInStore({}, errorObj ));
            });
        }//end of return
    }
    
    
    function uploadATowPictureOnServer( argURL, argFormData, argCompanyId  ,argIdToken, argUserId){
        
        var returnPromise = new Promise(function(resolve, reject){
            
            if((argURL != null) || (argURL.length != 0)){
                axios.all(getArrayOfPostsForUploadATowPicture(argURL, argFormData, argCompanyId  ,argIdToken, argUserId)).then(function(responses){
                    resolve(responses[0]);
                }, function(err) {
                    console.log("Farshid some error occured on saving a towjob " + err.message +  " the URL is " + argURL );
                    reject(err);
                });
            }
        });
        
        return returnPromise;
    }
    
    
    
    function getArrayOfPostsForUploadATowPicture(argURL, argFormData, argCompanyId ,argIdToken, argUserId){
        
        let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/uploads";
        console.log(" on posting a picture the URL is " + baseUrl );
        
        var arrayOfGets = [];
        if(argURL != null) {
            arrayOfGets.push(axios.post(baseUrl,argFormData ,{headers: {"Authorization" : `Bearer ${argIdToken}`, "Content-Type": "multipart/form-data"}} ));
        }
        return arrayOfGets;
    }
    
    
    /*  This was for test
		export function testUpload(){
				
				// let img1 = yourFile1
				//let img2 = yourFile2
				const formData = new FormData();
		// It is of paramount importance for these to have the same name (the first paramater - here 'images')else multer will give you a very cryptic error
				//formData.append("images", img1);
				//formData.append("images", img2);
		// you can of course append anything else you'd like
				formData.append("joke", "this is a poor mama joke");
				axios({
						method: "POST",
						url:  "http://localhost:2500/uploads",
						data: formData,
						headers: {
								"Content-Type": "multipart/form-data"
						}
				})
					.then(response => {
								if (response.status === 200) {
										console.log("Success, firm added")
								} else {
										console.log("Error occurred")
								}
						}
					).catch(e => {
						console.log(e)
				})
				
				
		}
		*/
    export function setTowStatusFilter(argStatus){
        return (dispatch) => {
            dispatch(setTowStatusFilterInStore(argStatus));
        }
    }
    
    export function setTowVinFilter(argStatus){
        return (dispatch) => {
            dispatch(setTowVinFilterInStore(argStatus));
        }
    }
    
    export function setTowPlateFilter(argStatus){
        return (dispatch) => {
            dispatch(setTowPlateFilterInStore(argStatus));
        }
    }
    
    export function setTowStartTimeFilter(argStatus){
        return (dispatch) => {
            dispatch(setTowStartTimeFilterInStore(argStatus));
        }
    }
    export function setTowEndTimeFilter(argStatus){
        return (dispatch) => {
            dispatch(setTowEndTimeFilterInStore(argStatus));
        }
    }
    
    export function setTowModelFilter(argStatus){
        return (dispatch) => {
            dispatch(setTowModelFilterInStore(argStatus));
        }
    }
    
    export function setTowMakeFilter(argStatus){
        return (dispatch) => {
            dispatch(setTowMakeFilterInStore(argStatus));
        }
    }
    
    
    export function setTowColorFilter(argStatus){
        return (dispatch) => {
            dispatch(setTowColorFilterInStore(argStatus));
        }
    }
    
    export function setTowYearFilter(argStatus){
        return (dispatch) => {
            dispatch(setTowYearFilterInStore(argStatus));
        }
    }
    
    export function clearTowAllFilters(){
        return (dispatch) => {
            dispatch(clearTowAllFiltersInStore());
        }
    }


//These are for loadTowJobsPictureIds
    export function loadTowJobsPictureIds(argURL, argTowId ) {
        return (dispatch, getState) => {
            const state = getState();
            getListOfTowJobsPictureIds(argURL, state.company.selectedCompany, state.login.loginData.idToken, state.user.saveUserResp.id, argTowId ).then(function(companysList){
                
                dispatch(loadTowJobsPictureIdsInStore(companysList));
                
            }, function(err){
                console.log("I had an error gettting loadTowJobsPictureIds" + err);
            });
        }//end of return
    }
    
    function getListOfTowJobsPictureIds( argURL, argCompanyId ,argIdToken, argUserId, argTowId ){
        
        var returnPromise = new Promise(function(resolve, reject){
            
            var arrayOfGets = [];
            
            if((argURL != null) || (argURL.length != 0)){
                axios.all(getArrayOfGetsForListOfTowJobsPictureIds(argURL, argCompanyId ,argIdToken, argUserId, argTowId )).then(function(responses){
                    resolve(responses[0].data);
                }, function(err) {
                    console.log("Farshid some error occured on getting list of Tow Jobs " + err.message +  " the URL is " + argURL );
                    reject(err);
                });
            }
        });
        
        return returnPromise;
    }
    function getArrayOfGetsForListOfTowJobsPictureIds(argURL,argCompanyId ,argIdToken, argUserId, argTowId  ){
        
        
        let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/towjobpictures/"+argTowId;
        console.log(" on getting list of towjobpictures  ids the URL is " + baseUrl );
        
        var arrayOfGets = [];
        if(argURL != null) {
            arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
        }
        return arrayOfGets;
    }
